import $ from 'jquery';

export default {
  init() {

    $('#play-video').on('click', function () {
        $('#insights-modal iframe').attr('src', $(this).data('url'));
        $('#insights-modal').fadeIn();
    });
    
    $('#insights-close').on('click', function() {
      $('#insights-modal').fadeOut();
      $('#insights-modal iframe').attr('src', null);
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/post-type-archive-insight.js